/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShipmentDocument
 */
export interface ShipmentDocument {
  /**
   *
   * @type {string}
   * @memberof ShipmentDocument
   */
  documentId: string;
  /**
   * Raw type, for the frontend to group by.
   * @type {string}
   * @memberof ShipmentDocument
   */
  documentType: string;
  /**
   * What to call it in front of a carrier.
   * @type {string}
   * @memberof ShipmentDocument
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDocument
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDocument
   */
  uploadedAt?: string;
}

/**
 * Check if a given object implements the ShipmentDocument interface.
 */
export function instanceOfShipmentDocument(
  value: object,
): value is ShipmentDocument {
  if (!("documentId" in value) || value["documentId"] === undefined)
    return false;
  if (!("documentType" in value) || value["documentType"] === undefined)
    return false;
  if (!("label" in value) || value["label"] === undefined) return false;
  return true;
}

export function ShipmentDocumentFromJSON(json: any): ShipmentDocument {
  return ShipmentDocumentFromJSONTyped(json, false);
}

export function ShipmentDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDocument {
  if (json == null) {
    return json;
  }
  return {
    documentId: json["documentId"],
    documentType: json["documentType"],
    label: json["label"],
    fileName: json["fileName"] == null ? undefined : json["fileName"],
    uploadedAt: json["uploadedAt"] == null ? undefined : json["uploadedAt"],
  };
}

export function ShipmentDocumentToJSON(json: any): ShipmentDocument {
  return ShipmentDocumentToJSONTyped(json, false);
}

export function ShipmentDocumentToJSONTyped(
  value?: ShipmentDocument | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    documentId: value["documentId"],
    documentType: value["documentType"],
    label: value["label"],
    fileName: value["fileName"],
    uploadedAt: value["uploadedAt"],
  };
}
